import Cache from 'root/cache';
import Constants from 'root/constants';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'feedback-history',

    initialize: function() {
    },

    render: function() {
        var content = '';

        var avatar = '';
        var avatar_class = 'user-24';
        var name = '';

        if (this.model.get('user_id') === Constants.BOT_JIRA) {
            avatar = '/image/jira_small.png';
            name   = 'Jira Bot';
        } else if (this.model.get('user_id') === Constants.BOT_CLICKUP) {
            avatar = '/image/clickup_small.png';
            name   = 'ClickUp Bot';
        } else if (this.model.get('user_id') === Constants.BOT_LINEAR) {
            avatar = '/image/linear_small.png';
            name   = 'Linear Bot';
        } else if (this.model.get('user_id') === Constants.BOT_EMAIL) {
            avatar = '/image/email_forwarding_small.png';
            avatar_class = 'history-icon';
            name   = 'Email Forwarding';
        } else if (this.model.get('is_slack_bot')) {
            avatar = '/image/slack_bot.png';
            name   = 'Slack Bot';
        } else {
            var user = Cache.user.get(this.model.get('user_id'));

            name   = user ? user.get('name') : 'Deleted user';
            avatar = user ? user.getAvatar() : Util.gravatar();
        }

        var content =

        '<div class="history-title">' +
            '<img class="'+ avatar_class +'" src="' + avatar + '">' +
            '<div class="history-user">' + name + '</div>' +
            '<div class="history-time">' + Util.moment(this.model.get('time'), 'DD MMM YYYY') + '</div>' +
        '</div>' +
        '<div class="history-msg">' + Util.htmlEntities(this.model.get('message')) + '</div>';

        this.$el.html(content);

        return this;
    }
});